export const ROSTER_BALANCE_REPORT_GET_GRADES =
  'ROSTER_BALANCE_REPORT_GET_GRADES';
export const ROSTER_BALANCE_REPORT_GET_TEACHERS =
  'ROSTER_BALANCE_REPORT_GET_TEACHERS';
export const ROSTER_BALANCE_REPORT_GET_REPORT =
  'ROSTER_BALANCE_REPORT_GET_REPORT';
export const ROSTER_BALANCE_REPORT_LOADING = 'ROSTER_BALANCE_REPORT_LOADING';
export const ROSTER_BALANCE_REPORT_LOADING_GRADES =
  'ROSTER_BALANCE_REPORT_LOADING_GRADES';
export const ROSTER_BALANCE_REPORT_ERRORS = 'ROSTER_BALANCE_REPORT_ERRORS';



// WEBPACK FOOTER //
// ./src/pages/rostercurrentbalance/state/roster/types.js